import { CustomElement } from "../../core/CustomElement";
import { formatDate, DateFormat } from "../../core/utilities";

class CCCDateDisplay extends CustomElement {
  $svg: SVGElement = null;
  $month: HTMLElement = null;
  $day: HTMLElement = null;
  $title: HTMLElement = null;

  static get observedAttributes() {
    return ["size", "date"];
  }

  constructor() {
    super();
    this.templateConfig = {
      template: require("./template.html").default,
      style: require("./style.scss").default,
    };
    this.setupComponent();
    this.$svg = this.shadowDom.querySelector("svg");
    this.$month = this.shadowDom.querySelector(".month");
    this.$day = this.shadowDom.querySelector(".day");
    this.$title = this.shadowDom.querySelector("title");
    if (!this.getAttribute("date")) {
      this.watchDate();
    }
  }

  attributeChangedCallback(attr: string, oldValue: string, newValue: string) {
    switch (attr) {
      case "size":
        if (oldValue && oldValue !== "") {
          this.removeClass(this.$svg, oldValue);
        } else {
          this.removeClass(this.$svg, "md");
        }
        this.setKeyState(attr, newValue);
        break;
      case "date":
        if (typeof newValue === "string") {
          // newValue = new Date(newValue);
          this.setKeyState(attr, new Date(newValue));
        } else {
          this.setKeyState(attr, newValue);
        }
        break;
      default:
        break;
    }
  }

  removeClass(element: Element, cssClass: string) {
    element.classList.remove(cssClass);
  }

  watchSize() {
    if (this.state.size) {
      this.$svg.classList.add(this.state.size);
    } else {
      this.setKeyState("size", "md");
    }
  }

  watchDate() {
    if (this.state.date) {
      const displayTime = this.getAttribute("displayTime");
      this.$month.textContent = formatDate(
        this.state.date,
        DateFormat.shortMonth
      ).toUpperCase();
      this.$day.textContent = formatDate(this.state.date, DateFormat.day);
      this.$title.textContent = formatDate(
        this.state.date,
        displayTime ? DateFormat.longDateTime : DateFormat.longDate
      );
    } else {
      this.setKeyState("date", new Date());
    }
  }
}

// define component
if (!customElements.get("ccc-date-display")) {
  customElements.define("ccc-date-display", CCCDateDisplay);
}
